export default __webpack_public_path__ + "static/media/hero.a21584d5.png";